/* Vicca cart timer — reserva de 10 minutos del carrito.
   Web component <vicca-cart-timer> renderizado en la cabecera del drawer.
   Guarda `vicca_cart_deadline` en localStorage al añadir el primer producto
   y muestra una cuenta atrás MM:SS; al llegar a 0 muestra el mensaje de
   expiración y borra la clave; si el carrito se vacía, borra la clave. */

const VICCA_CART_DEADLINE_KEY = 'vicca_cart_deadline';
const VICCA_CART_TIMER_MINUTES = 10;

class ViccaCartTimer extends HTMLElement {
  connectedCallback() {
    this.textEl = this.querySelector('.vicca-cart-timer__text');
    this.isEmpty = this.getAttribute('data-cart-empty') === 'true';
    this.label = this.getAttribute('data-label') || 'Tu carrito está reservado durante {{ time }}';
    this.expiredLabel =
      this.getAttribute('data-expired-label') || 'Tu reserva ha expirado, pero hemos guardado tus productos';

    if (this.isEmpty) {
      this.clearDeadline();
      this.hidden = true;
      return;
    }

    this.ensureDeadline();
    this.hidden = false;
    this.tick();
    this.interval = setInterval(this.tick.bind(this), 1000);
  }

  disconnectedCallback() {
    if (this.interval) clearInterval(this.interval);
  }

  ensureDeadline() {
    const existing = localStorage.getItem(VICCA_CART_DEADLINE_KEY);
    if (!existing) {
      const deadline = Date.now() + VICCA_CART_TIMER_MINUTES * 60 * 1000;
      try {
        localStorage.setItem(VICCA_CART_DEADLINE_KEY, String(deadline));
      } catch (e) {
        // localStorage unavailable, ignore
      }
    }
  }

  clearDeadline() {
    try {
      localStorage.removeItem(VICCA_CART_DEADLINE_KEY);
    } catch (e) {
      // ignore
    }
  }

  tick() {
    const deadline = parseInt(localStorage.getItem(VICCA_CART_DEADLINE_KEY), 10);

    if (!deadline || Number.isNaN(deadline)) {
      this.ensureDeadline();
      return;
    }

    const remaining = deadline - Date.now();

    if (remaining <= 0) {
      this.textEl.textContent = this.expiredLabel;
      this.clearDeadline();
      if (this.interval) clearInterval(this.interval);
      return;
    }

    const totalSeconds = Math.ceil(remaining / 1000);
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    const formatted = `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;

    this.textEl.textContent = this.label.replace('{{ time }}', formatted);
  }
}

if (!customElements.get('vicca-cart-timer')) {
  customElements.define('vicca-cart-timer', ViccaCartTimer);
}
